module.exports = __webpack_public_path__ + "img/aviva.b94f0636.png";